// src/pages/Inboxes.tsx

import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import PageLoader from "../../../../components/PageLoader";
import { selectInboxListItems } from "../../../../redux/inbox/selector";
import { inbox } from "../../../../redux/inbox/action";
import storePersist from "../../../../redux/storePersist";

const Inboxes = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const userProfileId = storePersist?.get("accessTokenMetadata")?.current?.TokenMetadata?.UserMetaData?.UserProfileId;
  const InboxItems = useSelector(selectInboxListItems);

  const handleReloadData = () => {
    dispatch(
      inbox.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/marketing/campaign-user-logs/list`,
        entity: "inbox",
        jsonData: {

          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "Id",
          SortOrder: "desc",

          "Filters": [
            {
              "FieldName": "UserProfileId",
              "FilterOperatorId": 1,
              "FieldValue": Number(userProfileId),
              "FieldType": "number"
            }],
        },
      })
    );
  };

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`, { state: data });
  };

  useEffect(() => {
    handleReloadData();
  }, [pageData, pageSize]);

  return (
    <>
      {InboxItems?.isLoading ? (
        <PageLoader />
      ) : (
        <div className="max-w-7xl mx-auto px-4 py-6">
          <h1 className="text-3xl font-bold text-indigo-900 text-center mb-6"> Inbox</h1>

          {InboxItems?.result?.items?.length > 0 ? (
            <div className="space-y-4">
              {InboxItems.result.items.map((item: any) => (
                <div
                  key={item.Id}
                  onClick={() => handleEdit(item)}
                  className="bg-white cursor-pointer hover:bg-gray-50 transition border rounded-lg p-4 shadow-sm"
                >
                  <div className="flex justify-between items-center">
                    <div>

                      <p className="text-sm text-gray-500">From: {item.FromEmailId} <b className="mt-2 text-gray-700"> || Subject: {item.Subject} </b></p>
                    </div>
                    <span className="text-sm text-gray-400">{new Date(item.LastReceivedOnUtc).toLocaleString()}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-gray-500 text-lg py-10">No inbox messages found.</div>
          )}
        </div>
      )}
    </>
  );
};

export default Inboxes;
